<template>
  <div class="forgotten-password-confirmed">
    <div>
      <img src="/assets/images/email-confirmation.svg" alt="" class="confirmation-icon"/>
      <h1 class="title">{{ $t('registration.emailConfirmation.title') }}</h1>
      <p class="description" v-html="$t('forgottenPasswordConfirmation.description', {email: email})"></p>

      <base-link :href="forgottenPasswordPage" variant="primary-button" class="confirmation-link">
        {{ $t('forgottenPasswordConfirmation.sendAgain') }}
      </base-link>
    </div>
    <div class="bottom-description">
      <hr>
      <span class="small-text">{{ $t('forgottenPasswordConfirmation.linkLabel') }}</span>
    </div>
  </div>
</template>

<script>
import { parseQueryString } from '@/utils/queryParser'
import { customRouter } from '@/customRouter'
import { addDataLayerEvent } from '@/services/dataLayer'

export default {
  name: 'page-forgotten-password-confirmation',
  data () {
    return {
      email: ''
    }
  },
  computed: {
    forgottenPasswordPage () {
      return customRouter.getRouteByName({ name: 'forgottenPassword' })
    }
  },
  created () {
    this.$nextTick(() => {
      const qs = parseQueryString()
      if (qs && Object.keys(qs)[0] === 'email') {
        this.email = qs.email
      } else {
        customRouter.goTo({ name: 'login' })
      }
    })

    addDataLayerEvent({
      event: 'screen',
      name: 'forgot_password_email_sent'
    })
  }
}
</script>

<style scoped lang="scss">
.forgotten-password-confirmed {
  margin: 0 auto;
  width: 100%;
  max-width: 68rem;
  background-color: $white;
  border-radius: 5px;
  text-align: center;
  padding: 4rem 4rem 2.4rem;
  height: calc(100vh - 67px);
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  @media (map_get($breakpoints, sm)) {
    margin-top: 13rem;
    height: auto;
    padding: 4rem;
  }

  @media (map_get($breakpoints, md)) {
    margin-top: 16rem;
    max-width: 84rem;
  }

  .title {
    font-size: 2rem;
    margin-top: 2.4rem;
    margin-bottom: 4rem;
    color: $text;
    font-weight: normal;

    @media (map_get($breakpoints, sm)) {
      font-weight: 600;
      font-size: 3.2rem;
    }
  }

  .description {
    color: $text-alt;
    margin: 0 auto 4rem;
    max-width: 60rem;
    font-size: 1.4rem;

    @media (map_get($breakpoints, sm)) {
      font-size: 1.6rem;
    }
  }

  .confirmation-link {
    width: 100%;

    @media (map_get($breakpoints, sm)) {
      width: auto;
    }
  }

  hr {
    margin-bottom: 1.6rem;
    @media (map_get($breakpoints, sm)) {
      width: 40rem;
      margin: 8rem auto 1.6rem;
      border-top: 1px solid #e1e1e1;
    }
  }

  .small-text {
    font-size: 1.2rem;
    color: #777777;
  }
}

</style>
